
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const warden: Operator = {
	id: 'warden',
	name: 'Warden',
	role: 'Defender',
	org: 'SECRET SERVICE',
	squad: 'GHOSTEYES',
	ratings: {
		health: 2,
		speed: 2,
		difficulty: 2
	},
	meta: {
		gender: 'm',
		country: 'us',
		season: 'Y4S2',
		height: 183,
		weight: 80,
		price: {
			renown: 10000,
			r6credits: 240
		}
	},
	bio: {
		real_name: 'Collinn McKinley',
		birthplace: 'Louisville, U.S.A'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M45 45h260v260H45z" style="opacity:.4"></path><path d="M73 73h204v204H73z" style="fill:#fff"></path><path d="m277 73-3.073-.01a15060 15060 0 0 0 5.031-26.031L234.056 73H116.639L71.573 46.906a588 588 0 0 1 4.844 26.093H73v65l17.361 15.833L73 157.415V277h204V157.5l-17.083-3.667L277 138.083z"></path><path d="m92.417 73.5 78.083 45.625-35.167 39.319-39.75-50.694zM175 116.667l38.694 34.055 42.195-34.805 8.59-48.084z" style="fill:#fff"></path><path d="m103.833 142.25 27.625 28.917L152.729 147l5.604 7.167-25.062 81.604zm90.271 2.938 19.563 17.368 40.187-33.723-44.562 100.375L190 151.528z" style="fill:#fff"></path><path d="m174.222 123.75 16.5 14.583-8.25 12.084 21.111 101.916-5.277 11.778h-57.598l-2.541-10.903L167 151.667l-7.833-11.084z" style="fill:#2d3b89"></path></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-warden'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
